import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-block-user',
  templateUrl: './icon-block-user.component.html',
  styleUrls: ['./icon-block-user.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconBlockUserComponent {}
